var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anquan_container"},[_c('i',{staticClass:"iconfont icon-anquanyinsi anquan"}),_c('h3',[_vm._v(_vm._s(_vm.$t('privacy.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('privacy.description')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }